import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <path
      key='0'
      fill='#000000'
      d='M11.8,14.4c-3.2,0-9.5,1.6-9.5,4.8V20c0,1.3,1,1.9,2.3,1.9h15c1,0,1.9-0.9,1.9-1.9v-0.8C21.4,16,15,14.4,11.8,14.4z'
    />,
    <path
      key='1'
      fill='#000000'
      d='M12.7,2.6c-0.5-0.2-1.1-0.2-1.6,0L7.5,4.2c-0.6,0.3-0.8,1-0.4,1.5l1.1,1.4h7.5l1-1.4c0.4-0.5,0.2-1.2-0.4-1.5L12.7,2.6z'
    />,
    <path
      key='2'
      fill='#000000'
      d='M15.9,7.8l-0.7,1.1c-0.2,0.3-0.6,0.5-0.9,0.5H9.6c-0.4,0-0.7-0.2-0.9-0.5L8.1,8C7.8,8.5,7.7,9.1,7.7,9.7
	c0,2.4,1.9,4.3,4.3,4.3s4.3-1.9,4.3-4.3C16.3,9.1,16.2,8.4,15.9,7.8z'
    />,
  ],
  'DriverRounded'
);

const DriverRoundedIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(DriverRoundedIcon);
